/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {
  // Add custom code below this line

  /**
   * COLLAPSIBLE
   */

  setupEventListenersForCollapsible();

  // Creates the event listeners
  function setupEventListenersForCollapsible() {
    // On collapsible item click
    document.querySelectorAll('.collapsible .collapsible-header').forEach((element) => {
      element.addEventListener('click', toggleCollapsibleContent);
    });
  }
  
  // Opens or closes the content of a collapsible item
  function toggleCollapsibleContent() {
    var target = event.currentTarget,
        collapsible = target.closest('.collapsible'),
        collapsibleHeader = collapsible.querySelector('.collapsible-header'),
        collapsibleContent = collapsible.querySelector('.collapsible-content');    
    
    collapsibleHeader.setAttribute('aria-expanded', (collapsibleHeader.getAttribute('aria-expanded') === 'false').toString());
    collapsible.classList.toggle('opened');
  }

  /**
   * FIXED SECTION
   */

  setupEventListenersForFixedSection();

  // Creates the event listeners
  function setupEventListenersForFixedSection() {
    // On close button click
    document.querySelectorAll('.section-close').forEach((element) => {
      element.addEventListener('click', hideSection);
    });
  }
  
  // Hides a section
  function hideSection() {    
    event.preventDefault();
    event.currentTarget.closest('.shopify-section').innerHTML = "";
  }

  /**
   * FOOTER
   */

  setupEventListenersForFooter();

  // Creates the event listeners
  function setupEventListenersForFooter() {
    // On modify cookies button click
    document.querySelectorAll('.footer__quicklinks [href="#modifyCookies"]').forEach((element) => {
      element.addEventListener('click', showAxeptio);
    });
  }
  
  // Shows Axeptio popup
  function showAxeptio() {    
    event.preventDefault();
    javascript:openAxeptioCookies();
  }

  /**
   * STICKY
   */

  var stickyElements = document.querySelectorAll('.sticky-root');
  
  stickyElements.forEach((element) => {
    createIntersectionObserver(element, intersectionCallback);
  });

  // The observer of the sticky element
  function createIntersectionObserver(element, callback) {
    let observer;  
    let options = {
      root: null,
      rootMargin: '0px',
      threshold: [0, 1],
    };
  
    observer = new IntersectionObserver(callback, options);
    observer.observe(element);
  }

  // Toggles a css class to know if an element is sticky
  function intersectionCallback(entries, observer) {    
    var stickyElement = entries[0].target.nextElementSibling.querySelector('.sticky');

    if (entries[0].target.classList.contains('sticky-root--bottom')) stickyElement = entries[0].target.previousElementSibling.querySelector('.sticky');
    
    if (entries[0].intersectionRatio === 0) { // no intersection 
      stickyElement.classList.add('is-pinned');
    } else if (entries[0].intersectionRatio === 1) { // fully intersects 
      stickyElement.classList.remove('is-pinned');
    }
  };

  /**
   * SLIDER
   */

  if (!customElements.get('flickity-slider')) {
    customElements.define('flickity-slider',
      class FlickitySlider extends HTMLElement {
        constructor() {
          super();

          this.flkty = null;
    
          this.initSlider();
        }
      
        // Initializes the slider
        initSlider() {
          if (window.innerWidth < 750 && this.dataset.flickityEnabledMobile == 'true') {
           this.flkty = new themeVendor.Flickity(this, {
              draggable: JSON.parse(this.dataset.draggable),
              freeScroll: JSON.parse(this.dataset.freeScroll),
              wrapAround: JSON.parse(this.dataset.wrapAround),
              groupCells: parseFloat(this.dataset.groupCellsMobile),
              autoPlay: parseInt(this.dataset.autoPlayMobile),
              adaptiveHeight: JSON.parse(this.dataset.adaptiveHeight),
              asNavFor: this.dataset.asNavFor,
              dragThreshold: parseInt(this.dataset.dragThreshold),
              selectedAttraction: parseFloat(this.dataset.selectedAttraction),
              friction: parseFloat(this.dataset.friction),
              cellSelector: this.dataset.cellSelector,
              initialIndex: parseInt(this.dataset.initialIndexMobile),
              accessibility: JSON.parse(this.dataset.accessibility),
              cellAlign: this.dataset.cellAlignMobile,
              contain: JSON.parse(this.dataset.contain),
              prevNextButtons: JSON.parse(this.dataset.prevNextButtonsMobile),
              pageDots: JSON.parse(this.dataset.pageDotsMobile),
            });
          }
    
          if (window.innerWidth >= 750 && window.innerWidth < 990 && this.dataset.flickityEnabledTablet == 'true') {
            this.flkty = new themeVendor.Flickity(this, {
              draggable: JSON.parse(this.dataset.draggable),
              freeScroll: JSON.parse(this.dataset.freeScroll),
              wrapAround: JSON.parse(this.dataset.wrapAround),
              groupCells: parseFloat(this.dataset.groupCellsTablet),
              autoPlay: parseInt(this.dataset.autoPlayTablet),
              adaptiveHeight: JSON.parse(this.dataset.adaptiveHeight),
              asNavFor: this.dataset.asNavFor,
              dragThreshold: parseInt(this.dataset.dragThreshold),
              selectedAttraction: parseFloat(this.dataset.selectedAttraction),
              friction: parseFloat(this.dataset.friction),
              cellSelector: this.dataset.cellSelector,
              initialIndex: parseInt(this.dataset.initialIndexTablet),
              accessibility: JSON.parse(this.dataset.accessibility),
              cellAlign: this.dataset.cellAlignTablet,
              contain: JSON.parse(this.dataset.contain),
              prevNextButtons: JSON.parse(this.dataset.prevNextButtonsTablet),
              pageDots: JSON.parse(this.dataset.pageDotsTablet),
            });
          }
      
          if (window.innerWidth >= 990 && this.dataset.flickityEnabledDesktop == 'true') {
            this.flkty = new themeVendor.Flickity(this, {
              draggable: JSON.parse(this.dataset.draggable),
              freeScroll: JSON.parse(this.dataset.freeScroll),
              wrapAround: JSON.parse(this.dataset.wrapAround),
              groupCells: parseFloat(this.dataset.groupCellsDesktop),
              autoPlay: parseInt(this.dataset.autoPlayDesktop),
              adaptiveHeight: JSON.parse(this.dataset.adaptiveHeight),
              asNavFor: this.dataset.asNavFor,
              dragThreshold: parseInt(this.dataset.dragThreshold),
              selectedAttraction: parseFloat(this.dataset.selectedAttraction),
              friction: parseFloat(this.dataset.friction),
              cellSelector: this.dataset.cellSelector,
              initialIndex: parseInt(this.dataset.initialIndexDesktop),
              accessibility: JSON.parse(this.dataset.accessibility),
              cellAlign: this.dataset.cellAlignDesktop,
              contain: JSON.parse(this.dataset.contain),
              prevNextButtons: JSON.parse(this.dataset.prevNextButtonsDesktop),
              pageDots: JSON.parse(this.dataset.pageDotsDesktop),
            });
          }
        }
      }
    );
  }

  if (!customElements.get('card-flickity-slider')) {
    customElements.define('card-flickity-slider',
      class CardFlickitySlider extends HTMLElement {
        constructor() {
          super();

          this.flkty = null;
          this.flktyViewport = null;
    
          this.initSlider();
          this.setupEventListeners();   
        }
      
        // Initializes the slider
        initSlider() {
          this.flkty = new themeVendor.Flickity(this, {
              wrapAround: false,
              groupCells: 1,
              adaptiveHeight: false,
              cellAlign: 'center',
              contain: true,
              prevNextButtons: true,
              pageDots: false,
            });

          this.flktyViewport = this.querySelector('.flickity-viewport');
        }

        // Creates the event listeners
        setupEventListeners() {
          window.addEventListener('resize', this.onWindowResize.bind(this));
        }

        // On window resize
        onWindowResize(event) {
          if (this.flktyViewport !== null) {
            let firstSliderCellHeight = this.querySelector('slider-cell').offsetHeight + 'px';
            this.flktyViewport.style.height = firstSliderCellHeight;
          }
        }
      }
    );
  }

  /**
   * TOGGLE BUTTON
   */

  class ToggleButton extends HTMLButtonElement {
    static observedAttributes = ["aria-expanded"];
    
    constructor() {
      super();
    }

    connectedCallback() {
      this.setupEventListeners();
    } 
    
    setupEventListeners() {
      this.addEventListener("click", this.onButtonClick.bind(this));
      this.addEventListener("openable-element:close", this.onOpenableElementClose.bind(this));
      this.addEventListener("openable-element:open", this.onOpenableElementOpen.bind(this));
    }  
    
    get isExpanded() {
      return this.getAttribute("aria-expanded") === "true";
    }
    
    set isExpanded(value) {
      this.setAttribute("aria-expanded", value ? "true" : "false");
    }
    
    get controlledElement() {
      return document.getElementById(this.getAttribute("aria-controls"));
    }
    
    attributeChangedCallback(name, oldValue, newValue) {
      switch (name) {
        case "aria-expanded":
          if (oldValue === "false" && newValue === "true") {
            this.controlledElement.setAttribute('data-toggle-id', this.id);
            this.controlledElement.setAttribute('data-href', this.dataset.href);
            this.controlledElement.open = true;
          } else if (oldValue === "true" && newValue === "false") {
            this.controlledElement.removeAttribute("data-toggle-id");
            this.controlledElement.removeAttribute("data-href");
            this.controlledElement.open = false;
          }
          break;
      }
    }
    
    onButtonClick() {
      this.isExpanded = !this.isExpanded;
    }

    onOpenableElementClose(event) {
      this.isExpanded = false;
      event.stopPropagation();
    }

    onOpenableElementOpen(event) {
      this.isExpanded = true;
      event.stopPropagation();
    }
  }
  
  customElements.define("toggle-button", ToggleButton, { extends: "button" });

  /**
   * OPENABLE ELEMENT
   */

  class OpenableElement extends HTMLElement {
    static observedAttributes = ["open"];
    
    constructor() {
      super();      
      
      this.closeButton = this.querySelector('[data-action="close"]');
      this.openableContent = this.querySelector('[data-openable-content]');
      this.overlay = document.documentElement.querySelector('.openable__overlay');

      if (this.closeButton) this.closeButton.addEventListener("click", this.onCloseButtonClick.bind(this));
      if (this.overlay) this.overlay.addEventListener("click", this.onCloseButtonClick.bind(this));
    }

    onCloseButtonClick(event) {
      event.stopPropagation();
      this.open = false;
    }
    
    get requiresLoading() {
      return this.hasAttribute("data-href");
    }
    
    get open() {
      return this.hasAttribute("open");
    }
    
    set open(value) {
      if (value) {
        (async () => {
          if (this.overlay) this.overlay.classList.add('active');
          await this.load();
          this.setAttribute("open", "");
        })();
      } else {
        if (this.overlay) this.overlay.classList.remove('active');
        this.removeAttribute("open");
      }
    }

    attributeChangedCallback(name, oldValue, newValue) {
      this.toggleButton = document.querySelector(`#${this.dataset.toggleId}`);
      
      switch (name) {
        case "open":
          if (oldValue === null && newValue === "") {
            if (this.toggleButton) this.toggleButton.dispatchEvent(new CustomEvent('openable-element:open', {bubbles: false}));
          } else if (newValue === null) {
            if (this.toggleButton) this.toggleButton.dispatchEvent(new CustomEvent('openable-element:close', {bubbles: false}));
          }
      }
    }

    async load() {
      if (!this.requiresLoading) {
        return;
      }
      const response = await fetch(this.dataset.href);
      const element = document.createElement("div");
      element.innerHTML = await response.text();
      this.openableContent.innerHTML = element.innerHTML;
      this.openableContent.scrollTop = 0;
      this.dispatchEvent(new CustomEvent('openable-element:loaded', {bubbles: false}));
    }
  };

  customElements.define("openable-element", OpenableElement);

  /**
   * DRAWER CONTENT
   */

  class DrawerContent extends OpenableElement {
    constructor() {
      super();
    }

    attributeChangedCallback(name, oldValue, newValue) {
      super.attributeChangedCallback(name, oldValue, newValue);
      switch (name) {
        case "open":
          if (oldValue === null && newValue === "") {
            document.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true, detail: this.openableContent }));
          } else if (newValue === null) {
            if (document.querySelector('.drawer--visible') === null) document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
          }
      }
    }
  };
  
  customElements.define("drawer-content", DrawerContent);

  /**
   * QUICK BUY DRAWER
   */
  
  class QuickBuyDrawer extends DrawerContent {
    constructor() {
      super();    
    }

    connectedCallback() {
      this.addEventListener("openable-element:loaded", this.onOpenableElementLoaded.bind(this));
    }

    onOpenableElementLoaded(event) {
      this.submitButton = this.querySelector('[name="add"]');
      if (this.submitButton) this.submitButton.addEventListener("click", this.onSubmitButtonClick.bind(this));
    }

    onSubmitButtonClick(event) {
      this.open = false;
    }
  };
  
  customElements.define("quick-buy-drawer", QuickBuyDrawer);

  /**
   * VERTICAL DRAWER
   */

  if (!customElements.get('vertical-drawer')) {
    customElements.define('vertical-drawer',
      class Popout extends HTMLElement {
        constructor() {
          super();
          
          this.elements = {
            closeButton: this.querySelector('.vertical-drawer__close')
          };
  
          this.setupEventListeners();
        }
      
        // Creates the event listeners
        setupEventListeners() {
          if (this.elements.closeButton !== null) this.elements.closeButton.addEventListener('click', this.onCloseButtonClick.bind(this));
        }
      
        // On clicking on the close button
        onCloseButtonClick(event) {        
          this.classList.remove('opened');
        }
      }
    );
  }

  /**
   * COUNTDOWN
   */

  if (!customElements.get('custom-countdown')) {
    customElements.define('custom-countdown',
      class CustomCountdown extends HTMLElement {
        constructor() {
          super();

          this.elements = {
            days: this.querySelector('[data-days]'),
            hours: this.querySelector('[data-hours]'),
            minutes: this.querySelector('[data-minutes]'),
            seconds: this.querySelector('[data-seconds]')
          };
  
          this.init();
        }
      
        // Initializes the countdown
        init() {
          var endDate = this.dataset.endDate,
              duration = parseInt(this.dataset.duration),
              expiredText = this.dataset.expiredText,
              block = this.closest('.block');

          if (duration > 0) {
            var dt = new Date(),
                endDate = dt.setHours(dt.getHours() + duration);
          } 

          var deadline = new Date(endDate).getTime();

          if (duration > 0 && !isNaN(localStorage.countdownDeadline)) deadline = parseInt(localStorage.countdownDeadline);

          this.classList.remove('hidden');
  
          var x = setInterval(() => {
            var now = new Date().getTime(),
                t = deadline - now;

            if (duration > 0) localStorage.countdownDeadline = deadline;
            
            var days = Math.floor(t / (1000 * 60 * 60 * 24)),
                hours = Math.floor((t % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
                minutes = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60)),
                seconds = Math.floor((t % (1000 * 60)) / 1000);            
            
            if (days > 0) this.elements.days.textContent = `${days}${window.theme.strings.shortDay} :`;
            this.elements.hours.textContent = `${hours}${window.theme.strings.shortHour} :`;
            this.elements.minutes.textContent = `${minutes}${window.theme.strings.shortMinute} :`;
            this.elements.seconds.textContent = `${seconds}${window.theme.strings.shortSecond}`;
  
            if (t < 0) {
              clearInterval(x);
              if (duration > 0 && !isNaN(localStorage.countdownDeadline)) localStorage.removeItem("countdownDeadline");
              
              if (expiredText != '') {
                block.innerHTML = expiredText;
              } else {
                this.elements.days.textContent = '0';
                this.elements.hours.textContent = '0';
                this.elements.minutes.textContent = '0';
                this.elements.seconds.textContent = '0';
                
                this.classList.add('hidden');
                block.classList.add('hidden');
              }             
            }
          }, 1000); 
        }
      }
    );
  }

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
